export default {
  "": "Selecionar",
  name: "Nome do produto",
  code: "Código do produto",
  category: "Categoria do produto",
  sell_value: "Preço de venda",
  cost_value: "Preço de compra",
  unit_label: "Unidade de Medida",
  brand: "Marca",
  restock_count: "Estoque mínimo",
  stock_count: "Quantidade em estoque",
  barcode: "Código de barras",
  ncm: "NCM",
  cest: "CEST",
  csosn: "CSOSN",
  cfop: "CFOP",
  pis: "PIS",
  cofins: "COFINS",
  origin: "Origem"
};



// WEBPACK FOOTER //
// ./src/core/enum/product-batch-labels.enum.js